import { render, staticRenderFns } from "./left-middle.vue?vue&type=template&id=1f5da961&scoped=true&"
import script from "./left-middle.vue?vue&type=script&lang=js&"
export * from "./left-middle.vue?vue&type=script&lang=js&"
import style0 from "./left-middle.vue?vue&type=style&index=0&id=1f5da961&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5da961",
  null
  
)

export default component.exports